import Action from "../actions";

export default function storeSelectionReducer(state = {
    storeList: [],
    total:0,
    selectedStoreId: null,
    selectedStore: null,
}, action) {
    if (action.type === Action.SET_STORE_SELECTION) {
        return action.data;
    }
    return state;
}
